export const ACTIVITY_DEFAULT_IMAGE_DOMAIN = 'public'
export const ACTIVITY_DEFAULT_IMAGE_DOMAIN_ID = 0
export const ACTIVITY_DEFAULT_IMAGE_MESSAGE_ID = -1
export const ACTIVITY_DEFAULT_IMAGE_MESSAGE = 'Please select domain'
export const ACTIVITY_DEFAULT_IMAGE_DOMAIN_WITH_ID = `${ACTIVITY_DEFAULT_IMAGE_DOMAIN_ID}_${ACTIVITY_DEFAULT_IMAGE_DOMAIN}`
